import { Component, OnInit, ViewChild, QueryList, ElementRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, AbstractControl, Validators, FormArray, FormBuilder, FormGroup, } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MapsAPILoader } from '@agm/core';

import { ManageListsService } from '../shared/services/manage-lists.service';
import { Bool } from 'aws-sdk/clients/clouddirectory';

@Component({
	selector: 'app-manage-lists',
	templateUrl: './manage-lists.component.html',
	styleUrls: ['./manage-lists.component.css']
})
export class ManageListsComponent implements OnInit {
	@ViewChild('search') public searchElementRef: QueryList<ElementRef>;

	address: Object = {}

	//Submit flags
	submitRegarding: Boolean = false
	submitStatus: Boolean = false
	submitSubject: Boolean = false
	submitItem: Boolean = false;
	submitSubItem: Boolean = false;
	submitCategory: Boolean = false;
	submitProduct: Boolean = false;
	submitStone: Boolean = false;
	submitSubStone: Boolean = false;

	//Vars to Store lists, if present
	regardingList: any
	statusList: any
	subjectList: any
	itemList: any;
	subitemList: any;
	categoryList: any;
	productSettingList: any;
	stoneSettingList: any;
	subStoneSettingList: any;

	//Define form groups to add items in each list
	addRegarding: FormGroup;
	addStatus: FormGroup;
	addMaterialStatus: FormGroup;
	addSubject: FormGroup;
	addItems: FormGroup;
	addSubItems: FormGroup;
	addCategory: FormGroup;
	addWarehouse: FormGroup;
	addProductSetting: FormGroup;
	addStoneSetting: FormGroup;
	addSubStoneSetting: FormGroup;
	materialType: any = [
		{ id: 1, name: 'Materials' },
		{ id: 1, name: 'Labor' },
		{ id: 1, name: 'Comissions' },
	]


	constructor(
		private mapsAPILoader: MapsAPILoader,
		private formBuilder: FormBuilder,
		private router: Router,
		private ngZone: NgZone,
		private spinnerService: Ng4LoadingSpinnerService,
		private manageListService: ManageListsService
	) { }

	ngOnInit() {
		this.setInitialLists();
		this.getUpdatedListofItems();

		this.mapsAPILoader.load().then(() => {
			let autocomplete = new google.maps.places.Autocomplete(<HTMLInputElement>document.getElementById('address-input-location'));
			autocomplete.addListener("place_changed", () => {
				this.ngZone.run(() => {
					// some details
					let place: google.maps.places.PlaceResult = autocomplete.getPlace();
					this.address = this.createAddressData(place)
				});
			});
		});

	}

	updateWarehouseStatus(value, id) {
		this.spinnerService.show()
		let data = {
			id: id,
			notForInventory: value
		}
		this.manageListService.updateWarehouseStatus(data).subscribe(response => {
			this.spinnerService.hide()			
		}, error => {
			this.spinnerService.hide()
		})
	}

	createAddressData(place) {
		let addressData = {};
		for (var ac = 0; ac < place.address_components.length; ac++) {
			var component = place.address_components[ac];
			switch (component.types[0]) {
				case "route":
					addressData['address1'] = component.long_name;
					break;

				case "sublocality_level_2":
					addressData['address2'] = component.long_name;
					break;

				case "sublocality_level_1":
					if (addressData['address2']) {
						addressData['address2'] = addressData['address2'] + ", " + component.long_name;
					} else {
						addressData['address2'] = component.long_name;
					}

					break;

				case "postal_code":
					addressData['zip'] = component.long_name;
					break;

				case 'locality':
					addressData['city'] = component.long_name;
					break;

				case 'administrative_area_level_1':
					addressData['state'] = component.long_name;
					break;
				case 'country':
					addressData['country'] = component.long_name;
					break;
				case "street_number":
					addressData['street_no'] = component.long_name;
					break;
			}
		};
		addressData['business_type'] = 'crm_address'
		addressData['latitude'] = place.geometry.location.lat();
		addressData['longitude'] = place.geometry.location.lng();
		return addressData;
	}

	//Check sessionStorage for lists
	setInitialLists() {
		this.addRegarding = this.formBuilder.group({
			'name': ['', Validators.required],
			'cat_id': ['', Validators.required]
		})
		this.addStatus = this.formBuilder.group({
			'name': ['', Validators.required]
		})
		this.addMaterialStatus = this.formBuilder.group({
			'name': ['', Validators.required]
		})
		this.addSubject = this.formBuilder.group({
			'name': ['', Validators.required]
		})
		this.addItems = this.formBuilder.group({
			'name': ['', Validators.required]
		})
		this.addSubItems = this.formBuilder.group({
			'name': ['', Validators.required]
		})
		this.addCategory = this.formBuilder.group({
			'name': ['', Validators.required],
			'tax': ['', Validators.required]
		})
		this.addProductSetting = this.formBuilder.group({
			'type': ['', Validators.required],
			'name': ['', Validators.required]
		})
		this.addStoneSetting = this.formBuilder.group({
			'type': ['', Validators.required],
			'name': ['', Validators.required]
		})
		this.addSubStoneSetting = this.formBuilder.group({
			'type': ['', Validators.required],
			'name': ['', Validators.required]
		})
		this.addWarehouse = this.formBuilder.group({
			'name': ['', Validators.required],
		})
		let a = sessionStorage.getItem('activityregarding')
		let b = sessionStorage.getItem('activitystatus')
		let c = sessionStorage.getItem('activitysubject')
		let d = sessionStorage.getItem('activityitems')
		let e = sessionStorage.getItem('opptypoccategory')
		let f = sessionStorage.getItem('productsettings')
		let g = sessionStorage.getItem('stonesettings')
		let h = sessionStorage.getItem('pocsubitems')
		let i = sessionStorage.getItem('substonesettings')

		if (a != null && a != undefined && a != 'undefined' && JSON.parse(a).length > 0) {
			this.regardingList = JSON.parse(a);
		} else {
			this.regardingList = ''
		}
		if (b != null && b != undefined && b != 'undefined' && JSON.parse(b).length > 0) {
			this.statusList = JSON.parse(b);
		} else {
			this.statusList = ''
		}
		if (c != null && c != undefined && c != 'undefined' && JSON.parse(c).length > 0) {
			this.subjectList = JSON.parse(c);
		} else {
			this.subjectList = ''
		}
		if (d != null && d != undefined && d != 'undefined' && JSON.parse(d).length > 0) {
			this.itemList = JSON.parse(d);
		} else {
			this.itemList = ''
		}
		if (e != null && e != undefined && e != 'undefined' && JSON.parse(e).length > 0) {
			this.categoryList = JSON.parse(e);
		} else {
			this.categoryList = ''
		}

		if (f != null && f != undefined && f != 'undefined' && JSON.parse(f).length > 0) {
			this.productSettingList = JSON.parse(f);
		} else {
			this.productSettingList = ''
		}

		if (g != null && g != undefined && g != 'undefined' && JSON.parse(g).length > 0) {
			this.stoneSettingList = JSON.parse(g);
		} else {
			this.stoneSettingList = ''
		}

		if (h != null && h != undefined && h != 'undefined' && JSON.parse(h).length > 0) {
			this.subitemList = JSON.parse(h);
		} else {
			this.subitemList = ''
		}

		if (i != null && i != undefined && i != 'undefined' && JSON.parse(i).length > 0) {
			this.subStoneSettingList = JSON.parse(i);
		} else {
			this.subStoneSettingList = ''
		}
	}

	//Fetch all form controls for html
	get regardingControls() {
		return this.addRegarding.controls;
	}
	get statusControls() {
		return this.addStatus.controls;
	}
	get MaterialStatusControls() {
		return this.addMaterialStatus.controls;
	}
	get subjectControls() {
		return this.addSubject.controls;
	}
	get itemControls() {
		return this.addItems.controls;
	}
	get subitemControls() {
		return this.addSubItems.controls;
	}
	get categoryControls() {
		return this.addCategory.controls;
	}
	get productSettingControls() {
		return this.addProductSetting.controls;
	}
	get stoneSettingControls() {
		return this.addStoneSetting.controls;
	}
	get subStoneSettingControls() {
		return this.addSubStoneSetting.controls;
	}
	get WarehouseControls() {
		return this.addWarehouse.controls;
	}

	//Delete individual items from list
	deleteListItem(type, id, field) {
		let self = this
		let confirmation = window.confirm('Are you sure you want to delete this item?')
		if (confirmation) {
			self.spinnerService.show()
			let data = {
				'table': type,
				'field': field,
				'id': id
			}
			self.manageListService.removeItemFromMasterList(data).subscribe(res => {
				if (type == 'activity_reg') {
					self.updateRegardingList()
				} else if (type == 'activity_status') {
					self.updateStatusList()
				} else if (type == 'activity_subject') {
					self.updateSubjectList()
				} else if (type == 'oppty_items') {
					self.updateItemList()
				} else if (type == 'oppty_sub_items') {
					self.updateSubItemList()
				} else if (type == 'oppty_poc_category') {
					self.updateCategoryList()
				} else if (type == 'warehouse_list') {
					self.getUpdatedListofItems()
				} else if(type == 'products_settings_list') {
					self.updateProductSettingList()
				} else if(type == 'stone_info_fields') {
					self.updateStoneSettingList()
				} else if(type == 'stone_info_subfields') {
					self.updateSubStoneSettingList()
				}
				self.spinnerService.hide()
			})
		}
	}

	// Delete individual items from oppty poc status type
	deleteItemFromList(table, field, id) {
		let self = this
		let confirmation = window.confirm('Are you sure you want to delete this item?')
		if (confirmation) {
			self.spinnerService.show()
			let data = {
				'table': table,
				'field': field,
				'id': id
			}
			self.manageListService.removeItemFromList(data).subscribe(res => {
				self.getUpdatedListofItems()
				self.spinnerService.hide()
			})
		}
	}


	//Submit functions for all 3 forms
	addRegardingSubmit() {
		this.spinnerService.show()
		this.submitRegarding = true
		if (this.addRegarding.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'activity_reg',
			'name': this.addRegarding.controls['name'].value,
			'cat_id': this.addRegarding.controls['cat_id'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitRegarding = false
			this.updateRegardingList()
		})
	}
	addStatusSubmit() {
		this.spinnerService.show()
		this.submitStatus = true
		if (this.addStatus.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'activity_status',
			'name': this.addStatus.controls['name'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitStatus = false
			this.updateStatusList()
		})
	}

	submitPocMatStatus: boolean = false;
	addMaterialStatusSubmit() {
		this.spinnerService.show()
		this.submitPocMatStatus = true
		if (this.addMaterialStatus.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'oppty_poc_status_type',
			'name': this.addMaterialStatus.controls['name'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitStatus = false
			this.getUpdatedListofItems()
		})
	}
	addSubjectSubmit() {
		this.spinnerService.show()
		this.submitSubject = true
		if (this.addSubject.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'activity_subject',
			'name': this.addSubject.controls['name'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitSubject = false
			this.updateSubjectList()
		})
	}
	addItemSubmit() {
		this.spinnerService.show()
		this.submitItem = true
		if (this.addItems.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'oppty_items',
			'name': this.addItems.controls['name'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitItem = false
			this.updateItemList()
		})
	}
	addSubItemSubmit() {
		this.spinnerService.show()
		this.submitSubItem = true
		if (this.addSubItems.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'oppty_sub_items',
			'name': this.addSubItems.controls['name'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitSubItem = false
			this.updateSubItemList()
		})
	}

	addCategorySubmit() {
		this.spinnerService.show()
		this.submitCategory = true
		if (this.addCategory.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'oppty_poc_category',
			'name': this.addCategory.controls['name'].value,
			'tax': this.addCategory.controls['tax'].value
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitCategory = false
			this.updateCategoryList()
		})
	}

	addProductSettingSubmit() {
		this.spinnerService.show()
		this.submitProduct = true
		if (this.addProductSetting.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'products_settings_list',
			'type': this.addProductSetting.controls['type'].value,
			'name': this.addProductSetting.controls['name'].value,
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitProduct = false
			this.updateProductSettingList()
		})
	}

	addStoneSettingSubmit() {
		this.spinnerService.show()
		this.submitStone = true
		if (this.addStoneSetting.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'stone_info_fields',
			'type': this.addStoneSetting.controls['type'].value,
			'name': this.addStoneSetting.controls['name'].value,
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitStone = false
			this.updateStoneSettingList()
		})
	}

	addSubStoneSettingSubmit() {
		this.spinnerService.show()
		this.submitSubStone = true
		if (this.addSubStoneSetting.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'stone_info_subfields',
			'type': this.addSubStoneSetting.controls['type'].value,
			'name': this.addSubStoneSetting.controls['name'].value,
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitStone = false
			this.updateSubStoneSettingList()
		})
	}

	submitWarehouse: boolean = false;
	addWarehouseSubmit() {
		this.spinnerService.show()
		this.submitWarehouse = true
		if (this.addWarehouse.invalid) {
			this.spinnerService.hide()
			return
		}
		let data = {
			'table': 'warehouse_list',
			'name': this.addWarehouse.controls['name'].value,
			'location': this.address
		}
		this.manageListService.addItemsToMasterList(data).subscribe(res => {
			this.spinnerService.hide()
			this.submitWarehouse = false
			this.getUpdatedListofItems()
		})
	}
	updateRegardingList() {
		this.manageListService.getRegarding().subscribe(res => {
			sessionStorage.setItem('activityregarding', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}

	updateStatusList() {
		this.manageListService.getStatus().subscribe(res => {
			sessionStorage.setItem('activitystatus', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}

	PocMaterialStatusList: any = '';
	WarehouseLists: any = '';
	getUpdatedListofItems() {
		this.PocMaterialStatusList = '';
		this.WarehouseLists = '';
		this.address = {}
		this.addWarehouse.reset()
		this.manageListService.getPOCMaterialStatus().subscribe(res => {
			this.setInitialLists();
			this.PocMaterialStatusList = res['data'];
			this.WarehouseLists = res['warehouses'];
		})
	}
	updateSubjectList() {
		this.manageListService.getSubject().subscribe(res => {
			sessionStorage.setItem('activitysubject', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}
	updateItemList() {
		this.manageListService.getItems().subscribe(res => {
			sessionStorage.setItem('activityitems', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}
	updateSubItemList() {
		this.manageListService.getSubItems().subscribe(res => {
			sessionStorage.setItem('pocsubitems', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}
	updateCategoryList() {
		this.manageListService.getCategory().subscribe(res => {
			sessionStorage.setItem('opptypoccategory', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}

	updateProductSettingList() {
		this.manageListService.getProductSetting().subscribe(res => {
			sessionStorage.setItem('productsettings', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}

	updateStoneSettingList() {
		this.manageListService.getStoneSetting().subscribe(res => {
			sessionStorage.setItem('stonesettings', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}

	updateSubStoneSettingList() {
		this.manageListService.getSubStoneSetting().subscribe(res => {
			sessionStorage.setItem('substonesettings', JSON.stringify(res['data']));
			this.setInitialLists()
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/manage-lists/manage-lists.component.ts